import React, { Component } from 'react';
import {Card, CardActions, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import './LinkComponent.css';
import './index.css';
class LinkComponent extends Component {

    render() {
        var el = null;
        return (
            <div className="Link-container">
        { this.props.data.map(function(item) {
            if (item.image) {
              el = (
                  <Card className="Link-card" key={item.url.toString()}>

            <CardTitle title={item.name} subtitle={item.url} showExpandableButton={true}/>
                  <CardMedia expandable={true}>
                    <img className="cardMedia link-img" src={item.image} alt="" />
                </CardMedia>
            <CardText expandable={true}>
                { item.description.map(function(line, key) {
                    return <p key={key}>{line}</p>
                })
                }
            </CardText>
            <CardActions expandable={true}>
              <FlatButton label="besuchen" target="_blank" href={item.url}/>
            </CardActions>
          </Card>

              );
            } else {
                el = (
            <Card className="Link-card" key={item.url.toString()}>

            <CardTitle title={item.name} subtitle={item.url} showExpandableButton={true}/>

            <CardText expandable={true}>
                { item.description.map(function(line, key) {
                    return <p key={key}>{line}</p>
                })
                }
            </CardText>
            <CardActions expandable={true}>
              <FlatButton label="besuchen" target="_blank" href={item.url}/>
            </CardActions>
          </Card>
         );
            }
           return el;
            })
        }
        </div>
        );
    }
};

export default LinkComponent;



// WEBPACK FOOTER //
// ./src/LinkComponent.js